class FP_Preload {
	constructor() {
		if (!window.IntersectionObserver) {
			return;
		}

		this.preload_items = document.querySelectorAll('.fp-preload');
		if (!this.preload_items.length) {
			return;
		}

		this.init();
	}
	
	init() {
		const self = this;

		this.preload_items.forEach(function(item) {
			const observer = new IntersectionObserver((entries) => {
				self.observerCallback(entries, observer)
			},
			{threshold: 0.1});

			observer.observe(item);
		});
	}

	observerCallback(entries, observer) {
		entries.forEach((entry, i) => {
			if (!entry.isIntersecting) {
				return;
			}

			if (entry.target.dataset.callbackFunction) {
				new Function(entry.target.dataset.callbackFunction).call(entry.target);
			}
		});
	}
}
class FP_Search {
	constructor() {
		this.searchBar = '.fp-search-bar';

		this.controller = new AbortController();
		this.controller.signal.addEventListener("abort", () => {
			document.querySelector(this.searchBar).classList.remove('searching');
		});
		
		this.initEvents();
	}

	initEvents() {
		document.addEventListener('click', function(e) {
			this.handleSearchResultsClose(e);

			this.widenSearchForm(e);
			this.resetSearchForm(e);
		}.bind(this));
		
		this.handleSearch();
	}

	handleSearchResultsClose(e) {
		const openResults = document.querySelector('.fp-search-bar.has-results');
		if (!openResults) {
			return;
		}

		// Do not allow the search results to be closed when clicking within the search form container
		if (e.target.closest('.fp-search-bar')) {
			return;
		}

		openResults.classList.remove('has-results');
		openResults.querySelector('.search-field').value = '';
		openResults.querySelector('.search-results').innerHTML = '';
	}

	debounce(callback, wait) {
		let timeout;
		return (...args) => {
			clearTimeout(timeout);
			timeout = setTimeout(function () { callback.apply(this, args); }, wait);
		};
	}

	/**
	 * Allows the user to search via AJAX
	 * 
	 * @return  mixed
	 */
	handleSearch() {
		if (!this.hasSearchForms())
		{
			return;
		}
		
		const self = this;

		document.addEventListener('keyup', this.debounce((e) => {
			// Abort previous AJAX request
			document.querySelector(this.searchBar).classList.remove('searching');
			this.controller.abort();

			// Set new signal
			this.controller = new AbortController();

			// Check if we can search
			if (!e.target.closest('.fp-search-bar.do-search')) {
				return;
			}

			let search_field = e.target.closest('.search-field');
			if (!search_field) {
				return;
			}

			// Abort empty search term
			if (search_field.value.trim() === '') {
				this.hideResults(e);
				return;
			}

			let search_bar = e.target.closest('.fp-search-bar');
			search_bar.classList.add('searching');

			const post_type = search_bar.querySelector('input[type="hidden"][name="post_type"]') ? search_bar.querySelector('input[type="hidden"][name="post_type"]').value : '';

			let url = new URL(fireplugins.ajax_url);
			let params = {
				s: search_field.value,
				post_type: post_type,
				nonce: search_bar.querySelector('input[type="hidden"][name="nonce"]').value,
				action: 'fp_docs_ajax_search'
			};
			Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))
	
			fetch(url, {
				signal: this.controller.signal
			})
			.then(function(response) {
				return response.json();
			})
			.then((resp) => {
				search_bar.classList.remove('searching');

				if (resp.response != '') {
					self.showResults(e, resp.response);
				} else {
					self.hideResults(e);
				}
			});
		}, 300));
	}

	/**
	 * Shows results
	 * 
	 * @param   {Event}		   e 
	 * @param   {HTMLEleemnt}  results 
	 * 
	 * @return  void
	 */
	showResults(e, results) {
		let search_bar = e.target.closest('.fp-search-bar');

		search_bar.querySelector('.search-results').innerHTML = results;
		search_bar.classList.add('has-results');
	}

	/**
	 * Hides results
	 * 
	 * @param   {Event} e 
	 * 
	 * @return  void
	 */
	hideResults(e) {
		let search_bar = e.target.closest('.fp-search-bar');
		search_bar.classList.remove('has-results');

		let search_results = search_bar.querySelector('.search-results');
		search_results.innerHTML = '';
	}

	/**
	 * Checks whether we have any search forms in the page
	 * 
	 * @return  bool
	 */
	hasSearchForms() {
		return document.querySelectorAll('.fp-search-bar.do-search').length > 0;
	}

	/**
	 * Animates the search form to full width of the parent container.
	 * 
	 * @param   {Event} e 
	 * 
	 * @return  void
	 */
	widenSearchForm(e) {
		let searchBar = e.target.closest(this.searchBar);
		if (!searchBar) {
			return;
		}

		// if its the search icon or result link, allow it to be clicked
		if (e.target.closest('button') || e.target.closest('li')) {
			return;
		}

		e.preventDefault();

		searchBar.classList.add('wide');
	}

	/**
	 * Resets the search form width to the initial state.
	 * 
	 * @param   {Event} e 
	 * 
	 * @return  void
	 */
	resetSearchForm(e) {
		let searchBar = e.target.closest(this.searchBar);
		if (searchBar) {
			return;
		}

		if (!document.querySelector(this.searchBar)) {
			return;
		}

		if (!document.querySelector(this.searchBar).classList.contains('wide')) {
			return;
		}
		
		document.querySelector(this.searchBar).classList.remove('wide');
	}
}
class FP_Login_Box {
	constructor() {
		this.elementWrapper = '.dropdown-wrapper-ui.login';
		this.element = '.header-login-box';
		this.loginBox = document.querySelector(this.element);

		if (!this.loginBox) {
			return;
		}
		
		this.initEvents();
	}

	initEvents() {
		document.addEventListener('mouseover', function(e) {
			this.stickyLoginDropdown(e);
		}.bind(this));

		document.addEventListener('click', function(e) {
			this.closeLoginDropdown(e);
		}.bind(this));
	}

	stickyLoginDropdown(e) {
		let box = e.target.closest(this.elementWrapper);
		if (!box) {
			return;
		}

		box.querySelector(this.element).classList.add('is-sticky');
	}

	closeLoginDropdown(e) {
		if (e.target.closest(this.element)) {
			return;
		}
		
		if (e.target.tagName.toLowerCase() === 'com-1password-button') {
			return;
		}
		
		this.loginBox.classList.remove('is-sticky');
	}
}
class FP_Utils {
	/**
	 * Detect when the document is ready even if the script is loaded async/defer
	 *
	 * @param {object} callback  The function to execute when the document is ready
	 */
	static onReady(callback) {
		if (document.readyState != 'loading') {
			callback();
			return;
		}
		
		document.addEventListener('DOMContentLoaded', callback);
	}
}

class FP_App {
	constructor() {
		new FP_Preload();

		this.copyToClipboardTimer = null;

		this.initEvents();
		this.initComponents();
	}

	initEvents() {
		this.toggleHeaderSecondaryBar();

		document.addEventListener('click', function(e) {
			this.handleMobileNavToggle(e);
			this.handleMenuChildOpenOnMobile(e);
			this.scrollToSection(e);
			this.copyLinkUrlToClipboard(e);
			this.openLinkOnNewWindow(e);
			this.toggleNotifications(e);
			this.hideNotifications(e);
		}.bind(this));

		window.addEventListener('scroll', function(e) {
			this.toggleHeaderSecondaryBar();
		}.bind(this));
	}

	initComponents() {
		new FP_Search();
		new FP_Login_Box();
	}

	hideNotifications(e) {
		let toggle = e.target.closest('.header-notifications--toggle');
		let toggleCounter = e.target.closest('.header-notifications--toggle--counter');
		let toggleDropdown = e.target.closest('.header-notifications--dropdown');
		if (toggle || toggleCounter || toggleDropdown) {
			return;
		}

		if (!document.querySelector('.header-notifications.is-open')) {
			return;
		}

		document.querySelector('.header-notifications.is-open').classList.remove('is-open');
	}

	toggleNotifications(e) {
		let btn = e.target.closest('.header-notifications--toggle');
		if (!btn) {
			return;
		}

		btn.closest('.header-notifications').classList.toggle('is-open');

		// Set cookie to hide notifications for 5 days
		let expire_date = new Date();
		expire_date.setTime(expire_date.getTime() + (5*24*60*60*1000));
		let expires = 'expires='+ expire_date.toUTCString();
		document.cookie = 'fireplugins_notifications=1;' + expires + '; path=/; secure';

		// Remove the notification badge
		if (btn.querySelector('span')) {
			btn.querySelector('span').remove();
		}
	}

	/**
	 * On page scroll, make the header secondary bar appear in fixed position
	 * 
	 * @param   {Event}  e 
	 * 
	 * @return  void
	 */
	toggleHeaderSecondaryBar() {
		let header = document.querySelector('.header');
		if (!header) {
			return;
		}

		// Ensure the header has the main menu in it
		if (!header.querySelector('nav.desktop')) {
			header.classList.add('is-static');
			return;
		}

		if (window.innerWidth <= 1023) {
			header.classList.remove('has-shadow');
		}
		
		var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		let popupPageSlideHeight = document.querySelector('.fb-pageslide .fb-inst') ? document.querySelector('.fb-pageslide .fb-inst').scrollTop + document.querySelector('.fb-pageslide .fb-inst').offsetHeight : 1;
		
		if (scrollTop > popupPageSlideHeight) {
			header.classList.add('has-shadow');
			header.classList.add('is-fixed');
		} else {
			header.classList.remove('has-shadow');
			header.classList.remove('is-fixed');
		}
	}

	/**
	 * Handles toggling mobile navigation
	 * 
	 * @param   {Event}  e 
	 * 
	 * @return  void
	 */
	handleMobileNavToggle(e) {
		if (!e.target.closest('.header-mobile-nav-toggle')) {
			return;
		}
		
		e.target.closest('.header').classList.toggle('mobile-nav-visible');
	}

	/**
	 * If a header nav item has children, it keeps it open for mobile devices.
	 * We do this because on mobile devices we cannot hover over an element
	 * and we wouldn't be able to access children menu items.
	 * 
	 * @param   {Event} e 
	 * 
	 * @return  void
	 */
	handleMenuChildOpenOnMobile(e) {
		// Run only on desktops
		const winWidth = window.innerWidth;
		if (winWidth < 770) {
			return;
		}
		
		// close all open header menu items
		let open_lis = document.querySelectorAll('.header li.open');
		if (open_lis) {
			open_lis.forEach(li => {
				li.classList.remove('open');
			});
		}

		let li = e.target.closest('li.menu-item-has-children');
		if (!li || e.target.closest('.sub-menu')) {
			return;
		}

		let anchor = li.querySelector(':scope > a').getAttribute('href');
		if (anchor === '' || anchor === '#') {
			e.preventDefault();
			
			li.classList.add('open');
		}
	}
	
	/**
	 * Handle details element toggle
	 * 
	 * @return  void
	 */
	handleDetailsToggle() {
		const details = document.querySelectorAll('details');
		if (!details) {
			return;
		}

		details.forEach((targetDetail) => {
			targetDetail.addEventListener('click', () => {
				details.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute('open');
					}
				});
			});
		});
	}

	/**
	 * Scrolls to given section by animating scroll position
	 * 
	 * @param   {Event}  e
	 * 
	 * @return  @return  void
	 */
	scrollToSection(e) {
		const to = e.target.closest('.scroll-to');
		if (!to) {
			return;
		}

		e.preventDefault();

		const section = to.hasAttribute('href') ? to.getAttribute('href') : '#' + to.id;

		const element = document.querySelector(section);
		let offset = 15;

		// take into consideration the height of the fixed header
		let header = document.querySelector('header.header');
		if (header) {
			offset += header.offsetHeight;
		}
		
		const bodyRect = document.body.getBoundingClientRect().top;
		const elementRect = element.getBoundingClientRect().top;
		const elementPosition = elementRect - bodyRect;
		const offsetPosition = elementPosition - offset;
		
		window.scrollTo({
			top: offsetPosition,
			behavior: 'smooth'
		});

		history.pushState(null, null, section);
	}

	/**
	 * Copy the anchor link to clipboard.
	 * 
	 * @param   {Event}  e 
	 * 
	 * @return  void
	 */
	copyLinkUrlToClipboard(e) {
		const link = e.target.closest('.fp-copy-link-to-clipboard');
		if (!link) {
			return;
		}

		e.preventDefault();

		if (this.copyToClipboard(link.href)) {
			window.clearTimeout(this.copyToClipboardTimer);
			
			link.classList.add('copied');
			
			this.copyToClipboardTimer = window.setTimeout(function() {
				link.classList.remove('copied');
			}, 2000);
		}
	}

	/**
	 * Copies given text to clipboard.
	 * 
	 * @param   {String}  text
	 * 
	 * @return  mixed
	 */
	copyToClipboard(text) {
		if (window.clipboardData && window.clipboardData.setData) {
			return window.clipboardData.setData("Text", text);
		} else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
			var textarea = document.createElement("textarea");
			textarea.textContent = text;
			textarea.style.position = "fixed";
			document.body.appendChild(textarea);
			textarea.select();
			try {
				return document.execCommand("copy");
			}
			catch (ex) {
				console.warn("Copy to clipboard failed.", ex);
				return false;
			}
			finally {
				document.body.removeChild(textarea);
			}
		}
	}

	/**
	 * Opens link in a new window.
	 * 
	 * @param   {Event} e 
	 * 
	 * @return  void
	 */
	openLinkOnNewWindow(e) {
		let anchor = e.target.closest('.fp-open-link-new-window');
		if (!anchor) {
			return;
		}

		e.preventDefault();

		const width = anchor.dataset.width || 350;
		const height = anchor.dataset.height || 250;
		
		const extra = "width=" + width + ",height=" + height;
		
		window.open(anchor.href, "", "meubar=no,toolbar=no,resizable=yes,scrollbars=yes," + extra);
	}
}

FP_Utils.onReady(function() {
	new FP_App();
});